import { atom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { ROUTES } from '../../../constants/RouteNameMapping';
import { ICompanyDataModel } from '../../../data-models/company.data-model';
import { IListDataModel } from '../../../data-models/list.data-model';
import { MoveListCompanyPayload } from '../../../schemas/CompanyList.schema';
import { useMoveListCompany } from '../../../services/hooks/useListActions';

export type MoveListItemFormState =
  | {
      show: true;
      company: ICompanyDataModel;
      sourceList: IListDataModel;
    }
  | {
      show: false;
      company: null;
      sourceList: null;
    };
export const moveListItemFormStateAtom = atom<MoveListItemFormState>({
  company: null,
  show: false,
  sourceList: null,
});

export function useResetMoveListItemFormState() {
  return useAtomCallback(
    useCallback((get, set) => {
      set(moveListItemFormStateAtom, { show: false, company: null, sourceList: null });
    }, [])
  );
}

interface IUseMoveListCompanyFormActionProps {
  company: ICompanyDataModel;
  sourceList: IListDataModel;
  onClose: () => void;
}

export function useMoveListCompanyFormAction({
  company,
  sourceList,
  onClose,
}: IUseMoveListCompanyFormActionProps) {
  const moveCompany = useMoveListCompany();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = useCallback(
    async (data: Pick<MoveListCompanyPayload, 'targetListId'>) => {
      setLoading(true);
      const success = await moveCompany({
        companyIds: [company.id],
        sourceListId: sourceList.id,
        targetListId: data.targetListId,
      });
      setLoading(false);
      if (success) {
        onClose();
        navigate(`/${ROUTES.COMPANIES}/${ROUTES.LISTS}/${data.targetListId}`);
      }
    },
    [moveCompany, company.id, sourceList.id, onClose, navigate]
  );

  return {
    onSubmit,
    loading,
  };
}
